/* global angular, _ */
( function () {
	'use strict';
	function attrCleaner () {
		function removeUnnecessaryAttr ( indicator ) {
			delete indicator.redac;
			indicator.questionText  = _.unescape( indicator.questionText );
			indicator.answerOptions = ( indicator.answerOptions || [] ).map( function ( optionObj ) {
				delete optionObj.redac;
				delete optionObj.tempValue;
				return optionObj;
			} );

			return indicator;
		}

		function removeEmptyAttr ( model ) {
			Object.keys( model ).forEach( function ( attr ) {
				if ( !String( model[ attr ] ) ) {
					delete model[ attr ];
				}
			} );

			return model;
		}

		return {
			'removeEmptyAttr'       : removeEmptyAttr,
			'removeUnnecessaryAttr' : removeUnnecessaryAttr
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'attrCleaner', attrCleaner );
} )();
